import cmp from './CellWrapper'

export default cmp
